import arquivoDownload from './download';
import upload from './upload';
import assinador from './assinador';

export default {
  upload,
  assinador,
  arquivoDownload,
};
